import React from "react";
import UserPageSection from "../sections/UserPageSection/Content";
const UserDashbordPage = () => {
  return <UserPageSection />;
};

export default UserDashbordPage;
